module.exports = "mutation UpdateUnit($unit:UpdateUnitInput!){updateUnit(unit:$unit){success}}"